/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { IOrganizationFields, Organization } from 'src/app/app-data/models/Organization';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { BehaviorSubject, EMPTY, of } from 'rxjs';
import { DefaultActionTypes, PersistDataAction } from '../generics/DefaultActionTypes';
import { switchMap } from 'rxjs/operators';
import { FancyAction } from '../base/FancyAction';

export class OrganizationList extends FancyFirebaseSplitDataList<
	IOrganizationFields,
	DefaultSplitDataRenderType,
	Organization
> {
	public editList$: BehaviorSubject<Map<string, Organization>> = new BehaviorSubject(new Map());

	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);

		const ob$ = this.makeSimpleSublist(DefaultSplitDataRenderType.edit);
		this.subscriptions.push(ob$.subscribe(this.editList$));
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const organization = new Organization(action.payload.key);
		organization.databaseUpdate(action.payload.val());
		return organization;
	}

	public $$updated(child: Organization, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	public handleCustomEvents(baseObservable) {
		// Run our overrides first
		const wrappedOb$ = baseObservable.pipe(
			switchMap((action: FancyAction<Organization>) => {
				if (action.type === DefaultActionTypes.persistData) {
					this.handlePersistData(action as PersistDataAction);
					return EMPTY; //we handled it
				}
				return of(action);
			})
		);
		return super.handleCustomEvents(wrappedOb$);
	}

	// We override this because Organization data is saved via cloud functions,
	// but the "localDataNotYetPersisted" still needs to be updated
	private handlePersistData(action: PersistDataAction<Organization>) {
		const org = action.payload;
		org.localDataNotYetPersisted = false;
	}
}
